import React from 'react';
import styled from 'styled-components';

interface ImageContainerProps {
    src: string;
    alt: string;
    aspectRatio?: string;
    objectFit?: 'cover' | 'contain';
}

const StyledImageWrapper = styled.div<{ $aspectRatio?: string }>`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    overflow: hidden;
    border-radius: 0;
`;

const StyledImage = styled.img<{ $objectFit: 'cover' | 'contain' }>`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: ${({ $objectFit }) => $objectFit};
    display: block;
`;

export const ImageContainer: React.FC<ImageContainerProps> = ({ 
    src, 
    alt, 
    aspectRatio,
    objectFit = 'cover'
}) => {
    return (
        <StyledImageWrapper $aspectRatio={aspectRatio}>
            <StyledImage 
                src={src} 
                alt={alt} 
                loading="lazy"
                $objectFit={objectFit}
            />
        </StyledImageWrapper>
    );
};
